<script>
import Base from '@/plans/ZOOM_CLIPS/config/base';
import { plansof } from '@/utils/chain';
import { planTypes } from '@/common/constants';

export default {
  name: "ZoomClipsPlusAdd",
  extends: Base,
  computed: {
    alertMsg() {
      // Zoom United bundles will not receive any version of Zoom Clips!
      const zoomMeeting = plansof(this.boughtPlans)
        .type(planTypes.ZOOM_MEETING, planTypes.ZOOM_ONE, planTypes.ZOOM_ONE_BUNDLE).get();
      return zoomMeeting.length ? this.$t('billing.zoom_clips_plus.current_account_includes_zoom_clips') : ''
    }
  }
};
</script>
